"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgAddRoute(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "3 -4 18 24" }, props),
        React.createElement("path", { d: "M18 0a2 2 0 11-.536 3.927l-2.758 2.775a3 3 0 01-3.986 4.011l-2.774 2.825a2 2 0 11-1.375-1.455l2.727-2.777A3 3 0 0113.29 5.29l2.773-2.79A2.004 2.004 0 0118 0zm-6 7a1 1 0 100 2 1 1 0 000-2zM7 0v2h2v2H7v2H5V3.999L3 4V2l2-.001V0z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('AddRoute')(SvgAddRoute);
//# sourceMappingURL=AddRoute.js.map